module.exports = __webpack_public_path__ + "img/cc-mbs-square.b48d1589.png";